import {
  ApplicationNotification,
  NotificationApiService,
} from '@abb-procure/data';
import {
  Component,
  Input,
  ViewEncapsulation,
  booleanAttribute,
  inject,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-global-notification',
  templateUrl: './global-notification.component.html',
  styleUrl: './global-notification.component.scss',
  imports: [MatIcon, Button],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class GlobalNotification {
  @Input() notification?: ApplicationNotification | null = null;
  @Input({ transform: booleanAttribute }) preview: boolean = false;

  readonly acceptNotification = output<void>();

  private readonly notificationApiService = inject(NotificationApiService);

  async onAccept(): Promise<void> {
    if (!this.notification) {
      return;
    }

    if (this.preview) {
      this.acceptNotification.emit();
      return;
    }

    const response = await this.notificationApiService.confirmNotification(
      this.notification.notificationId,
    );

    if (!response || !this.notification) {
      return;
    }

    this.notification.display = false;
  }
}
